__turbopack_context__.v({
  "className": "roboto_6c062719-module__FJuJFW__className",
  "variable": "roboto_6c062719-module__FJuJFW__variable",
});
